module.exports = __webpack_public_path__ + "img/30_6.6aefdb4a.png";